import React, { useState } from 'react';
import { CheckCircle, MessageSquare, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';
import { negotiationService } from '../../../services/negotiationService';

export default function ActionButtons({ offer, onAccept }) {
  const navigate = useNavigate();
  const [accepting, setAccepting] = useState(false);
  const [negotiating, setNegotiating] = useState(false);
  const [negError, setNegError] = useState('');

  const wishType = offer?.wishType?.toLowerCase();
  const showAccept = wishType === 'prodaja';

  const handleNegotiate = async () => {
    setNegError('');
    setNegotiating(true);
    try {
      const { data: { session } } = await supabase?.auth?.getSession();
      const user = session?.user;
      if (!user) {
        navigate('/login');
        return;
      }

      if (offer?.userId === user?.id) {
        setNegError('Ne možete pregovarati sa samim sobom');
        setNegotiating(false);
        return;
      }

      // Create negotiation record
      const neg = await negotiationService?.startMarketplaceNegotiation(
        offer?.id,
        offer,
        `Zainteresovan/a sam za: ${offer?.voucherName || offer?.wishTitle || 'vaš oglas'}`
      );

      navigate('/my-negotiations-moja-pregovaranja', {
        state: {
          negotiationId: neg?.id,
          offerId: offer?.id,
          offerName: offer?.voucherName || offer?.wishTitle || 'Oglas',
          offerType: offer?.wishType,
        }
      });
    } catch (err) {
      setNegError(err?.message || 'Greška pri pokretanju pregovaranja');
    } finally {
      setNegotiating(false);
    }
  };

  const handleAccept = async () => {
    if (!onAccept) return;
    setAccepting(true);
    try {
      await onAccept(offer);
    } finally {
      setAccepting(false);
    }
  };

  return (
    <div className="flex flex-col gap-3 pt-2">
      {negError && (
        <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
          {negError}
        </p>
      )}
      <div className="flex flex-col sm:flex-row gap-3">
        {showAccept && (
          <button
            onClick={handleAccept}
            disabled={accepting}
            className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-teal-700 text-white rounded-xl font-semibold hover:bg-teal-800 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {accepting ? (
              <Loader2 size={18} className="animate-spin" />
            ) : (
              <CheckCircle size={18} />
            )}
            Prihvatam
          </button>
        )}
        <button
          onClick={handleNegotiate}
          disabled={negotiating}
          className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed ${
            showAccept
              ? 'border-2 border-teal-700 text-teal-700 hover:bg-teal-50' :'bg-teal-700 text-white hover:bg-teal-800'
          }`}
        >
          {negotiating ? (
            <Loader2 size={18} className="animate-spin" />
          ) : (
            <MessageSquare size={18} />
          )}
          Započni pregovaranje
        </button>
      </div>
    </div>
  );
}
